<template>
  <div>
    <div class="card mb-2">
      <div class="card-body d-flex justify-content-between align-items-start flex-wrap">
        <div>
          <div class="d-flex align-items-center flex-wrap mb-1">
            <input
              type="text"
              class="form-control form-control-lg mr-2 mb-1"
              style="max-width: 380px"
              v-model="device.title"
              placeholder="Título do dispositivo"
            />
            <span class="badge badge-secondary mr-1 mb-1">{{ device.code }}</span>
            <span v-if="online" class="badge badge-success mr-1 mb-1">Online</span>
            <span v-else class="badge badge-danger mr-1 mb-1">Offline</span>
            <span v-if="device.status == 1" class="badge badge-success mb-1">Ativo</span>
            <span v-else class="badge badge-secondary mb-1">Inativo</span>
          </div>
          <small class="text-muted d-block">
            Última sincronização: {{ device.ultima_sincronizacao || "Nunca sincronizou" }}
          </small>
          <small class="text-muted d-flex align-items-center flex-wrap mt-1">
            <span class="mr-1">Frequência de heartbeat:</span>
            <template v-if="editandoIntervalo">
              <input
                type="number"
                min="10"
                max="3600"
                class="form-control form-control-sm d-inline-block mr-1"
                style="width: 90px"
                v-model.number="novoIntervalo"
              />
              <span class="mr-1">s</span>
              <a class="mr-2" title="Salvar" @click="salvarIntervalo">
                <i class="fa fa-check text-success"></i>
              </a>
              <a title="Cancelar" @click="editandoIntervalo = false">
                <i class="fa fa-times text-danger"></i>
              </a>
            </template>
            <template v-else>
              <span class="mr-1">{{ device.heartbeat_interval || 60 }}s</span>
              <a
                class="mr-2"
                title="Alterar frequência (aplicado só após o próximo heartbeat do dispositivo)"
                @click="abrirEdicaoIntervalo"
              >
                <i class="fas fa-pencil-alt"></i>
              </a>
              <span class="mr-1">•</span>
              <span>Próxima sincronização: {{ contagemRegressiva || "-" }}</span>
            </template>
          </small>
        </div>
        <div class="text-nowrap">
          <router-link to="/devices" class="btn btn-back">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-add ml-1" @click="salvar">
            <i class="fa fa-save"></i> Salvar
          </a>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 d-flex">
        <div class="card w-100">
          <div class="card-header">
            <div class="card-title">Vínculos e Descrição</div>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label>Unidade:</label>
              <v-select :options="unidades" :label="'nome'" :reduce="(unidades) => unidades.id"
                v-model="device.unidade_id"></v-select>
            </div>
            <div class="form-group">
              <label>Grupo:</label>
              <v-select :options="gruposFiltrados" :label="'nome'" :reduce="(grupos) => grupos.id"
                v-model="device.grupo_id"></v-select>
              <small class="text-muted">
                Mostrando grupos da unidade selecionada e grupos gerais (sem unidade vinculada).
              </small>
            </div>
            <div class="form-group">
              <label>Descrição:</label>
              <textarea class="form-control" rows="3" v-model="device.description"></textarea>
            </div>
            <div class="form-group">
              <label>Status:</label>
              <select class="form-control" v-model="device.status">
                <option value="1">Ativo</option>
                <option value="0">Inativo</option>
              </select>
            </div>
            <hr />
            <div class="row text-center">
              <div class="col-4">
                <small class="text-muted d-block">IP Local</small>
                {{ device.ip_local || "-" }}
              </div>
              <div class="col-4">
                <small class="text-muted d-block">AnyDesk ID</small>
                {{ device.id_anydesk || "-" }}
              </div>
              <div class="col-4">
                <small class="text-muted d-block">Hostname</small>
                {{ device.hostname || "-" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 d-flex">
        <div class="card w-100">
          <div class="card-header">
            <div class="card-title">Print de Tela</div>
          </div>
          <div class="card-body text-center d-flex flex-column justify-content-center">
            <div v-if="device.screenshot_url" class="screenshot-thumb" @click="abrirPrintGrande">
              <img :src="device.screenshot_url" class="img-fluid rounded" />
              <div class="mt-1">
                <small class="text-muted">{{ device.screenshot_at }}</small>
              </div>
            </div>
            <div v-else class="screenshot-placeholder text-muted">
              <i class="fa fa-desktop fa-3x"></i>
              <div class="mt-1">Nenhum print solicitado ainda</div>
            </div>
            <button class="btn btn-add mt-2" @click="solicitarPrint">
              <i class="fa fa-camera"></i> Solicitar Print de Tela
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-2">
      <div class="card-header">
        <div class="card-title">Enviar Comando</div>
      </div>
      <div class="card-body">
        <div class="d-flex flex-wrap comando-rapido-group">
          <button class="btn btn-outline-secondary" @click="enviarComandoRapido('reboot')">
            <i class="fa fa-power-off"></i> Reiniciar
          </button>
          <button class="btn btn-outline-secondary" @click="enviarComandoRapido('shutdown')">
            <i class="fa fa-stop-circle"></i> Desligar
          </button>
          <button class="btn btn-outline-secondary" @click="enviarComandoRapido('restart_anydesk')">
            <i class="fa fa-refresh"></i> Reiniciar AnyDesk
          </button>
          <button class="btn btn-outline-secondary" @click="enviarComandoRapido('update_client')">
            <i class="fa fa-download"></i> Atualizar Client
          </button>
          <button class="btn btn-outline-secondary" @click="definirSenhaAnydesk">
            <i class="fas fa-key"></i> Definir Senha AnyDesk
          </button>
        </div>
        <hr />
        <div class="form-group mb-0">
          <label>Comando customizado:</label>
          <textarea class="form-control" rows="2" v-model="comandoCustomizado" placeholder="ex: echo teste"></textarea>
          <button class="btn btn-add mt-1" @click="enviarComandoCustomizado">
            <i class="fa fa-terminal"></i> Enviar Comando Customizado
          </button>
        </div>
      </div>
    </div>

    <div class="card mt-2">
      <div class="card-header">
        <div class="card-title">Histórico de Comandos</div>
      </div>
      <div class="card-body p-0">
        <table class="table mb-0">
          <thead>
            <tr>
              <th>Comando</th>
              <th>Status</th>
              <th>Resultado</th>
              <th>Criado em</th>
              <th>Executado em</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="comando in comandos" :key="comando.id">
              <td>{{ comando.comando }}</td>
              <td>
                <span :class="statusBadgeClass(comando.status)">{{ statusLabel(comando.status) }}</span>
              </td>
              <td class="text-truncate" style="max-width: 320px">{{ comando.resultado || "-" }}</td>
              <td>{{ comando.created_at }}</td>
              <td>{{ comando.executado_em || "-" }}</td>
            </tr>
            <tr v-if="comandos.length === 0">
              <td colspan="5" class="text-center text-muted py-2">Nenhum comando enviado ainda</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal fade" id="printGrandeModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Print de Tela - {{ device.screenshot_at }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <img v-if="device.screenshot_url" :src="device.screenshot_url" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  name: "deviceDetail",
  data() {
    return {
      device: { status: "1" },
      unidades: [],
      grupos: [],
      comandos: [],
      comandoCustomizado: "",
      pollInterval: null,
      tickInterval: null,
      agora: new Date(),
      editandoIntervalo: false,
      novoIntervalo: 60,
      deviceCarregado: false,
    };
  },
  computed: {
    online: function () {
      if (!this.device.ultima_sincronizacao) {
        return false;
      }
      const ultima = new Date(this.device.ultima_sincronizacao.replace(" ", "T"));
      return (Date.now() - ultima.getTime()) / 60000 <= 2;
    },
    proximaSincronizacaoEm: function () {
      if (!this.device.ultima_sincronizacao) {
        return null;
      }
      const ultima = new Date(this.device.ultima_sincronizacao.replace(" ", "T"));
      const intervalo = this.device.heartbeat_interval || 60;
      return new Date(ultima.getTime() + intervalo * 1000);
    },
    contagemRegressiva: function () {
      if (!this.proximaSincronizacaoEm) {
        return null;
      }
      const restanteMs = this.proximaSincronizacaoEm.getTime() - this.agora.getTime();
      if (restanteMs <= 0) {
        return "a qualquer momento";
      }
      const totalSeg = Math.ceil(restanteMs / 1000);
      const min = Math.floor(totalSeg / 60);
      const seg = totalSeg % 60;
      return min > 0 ? `${min}m ${String(seg).padStart(2, "0")}s` : `${seg}s`;
    },
    gruposFiltrados: function () {
      const unidadeId = this.device.unidade_id;
      if (!unidadeId) {
        return this.grupos;
      }
      return this.grupos.filter(
        (grupo) => !grupo.unidade_id || grupo.unidade_id == unidadeId
      );
    },
  },
  watch: {
    "device.unidade_id": function () {
      if (!this.deviceCarregado) {
        return;
      }
      const aindaValido = this.gruposFiltrados.some(
        (grupo) => grupo.id === this.device.grupo_id
      );
      if (!aindaValido) {
        this.device.grupo_id = null;
      }
    },
  },
  methods: {
    getDevice: function (somenteTelemetria) {
      const self = this;
      const id = self.$route.params.id;
      const api = self.$store.state.api + "devices/" + id;

      axios
        .get(api)
        .then((response) => {
          const atualizado = response.data.data[0];

          if (somenteTelemetria) {
            // Poll periódico: atualiza só o que o dispositivo reporta sozinho,
            // sem sobrescrever título/descrição/unidade/grupo/status que o
            // operador pode estar editando na tela nesse momento.
            Object.assign(self.device, {
              ultima_sincronizacao: atualizado.ultima_sincronizacao,
              ip_local: atualizado.ip_local,
              id_anydesk: atualizado.id_anydesk,
              hostname: atualizado.hostname,
              screenshot_url: atualizado.screenshot_url,
              screenshot_at: atualizado.screenshot_at,
              heartbeat_interval: atualizado.heartbeat_interval,
            });
          } else {
            self.device = atualizado;
            self.$nextTick(function () {
              self.deviceCarregado = true;
            });
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data || [];
        })
        .catch(() => {});
    },
    getGrupos: function () {
      const self = this;
      const api = self.$store.state.api + "grupos?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.grupos = response.data.data || [];
        })
        .catch(() => {});
    },
    getComandos: function () {
      const self = this;
      const id = self.$route.params.id;
      const api =
        self.$store.state.api +
        "comandos?device_id=" +
        id +
        "&orderByDesc=created_at&paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.comandos = response.data.data || [];
        })
        .catch(() => {});
    },
    salvar: function () {
      const self = this;
      const api = self.$store.state.api + "devices/" + self.device.id;
      const payload = Object.assign({}, self.device, { _method: "PUT" });

      axios
        .post(api, payload)
        .then(() => {
          self.$message("Sucesso", "Informações guardadas com sucesso", "success");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    enviarComando: function (comando, payload) {
      const self = this;
      const api = self.$store.state.api + "comandos";

      axios
        .post(api, { device_id: self.device.id, comando: comando, payload: payload })
        .then(() => {
          self.$message("Sucesso", "Comando enfileirado com sucesso", "success");
          self.getComandos();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    enviarComandoRapido: function (comando) {
      this.enviarComando(comando);
    },
    definirSenhaAnydesk: function () {
      this.enviarComando("custom", 'echo "4c3550#01" | sudo anydesk --set-password');
    },
    enviarComandoCustomizado: function () {
      if (!this.comandoCustomizado) {
        this.$message("Ops", "Informe o comando a executar", "error");
        return;
      }
      this.enviarComando("custom", this.comandoCustomizado);
      this.comandoCustomizado = "";
    },
    solicitarPrint: function () {
      this.enviarComando("screenshot");
    },
    abrirEdicaoIntervalo: function () {
      this.novoIntervalo = this.device.heartbeat_interval || 60;
      this.editandoIntervalo = true;
    },
    salvarIntervalo: function () {
      const novo = this.novoIntervalo;
      if (!novo || novo < 10 || novo > 3600) {
        this.$message("Ops", "Informe um valor entre 10 e 3600 segundos", "error");
        return;
      }
      this.enviarComando("set_heartbeat_interval", String(novo));
      this.editandoIntervalo = false;
    },
    abrirPrintGrande: function () {
      $("#printGrandeModal").modal("show");
    },
    statusBadgeClass: function (status) {
      const map = {
        pendente: "badge badge-secondary",
        enviado: "badge badge-info",
        executando: "badge badge-info",
        concluido: "badge badge-success",
        falhou: "badge badge-danger",
      };
      return map[status] || "badge badge-secondary";
    },
    statusLabel: function (status) {
      const map = {
        pendente: "Pendente",
        enviado: "Enviado",
        executando: "Executando",
        concluido: "Concluído",
        falhou: "Falhou",
      };
      return map[status] || status;
    },
  },
  mounted: function () {
    const self = this;
    self.getUnidades();
    self.getGrupos();
    self.getDevice();
    self.getComandos();
    self.pollInterval = setInterval(function () {
      self.getDevice(true);
      self.getComandos();
    }, 5000);
    self.tickInterval = setInterval(function () {
      self.agora = new Date();
    }, 1000);
  },
  beforeDestroy: function () {
    clearInterval(this.pollInterval);
    clearInterval(this.tickInterval);
  },
  components: {
    vSelect,
  },
};
</script>

<style scoped>
.screenshot-thumb {
  cursor: pointer;
  display: inline-block;
}

.screenshot-thumb img {
  max-height: 220px;
  border: 1px solid #ddd;
}

.screenshot-placeholder {
  padding: 40px 0;
}

.comando-rapido-group .btn {
  margin: 0 8px 8px 0;
  white-space: nowrap;
}

.comando-rapido-group .btn i {
  margin-right: 4px;
}
</style>
